import React from "react";
import { ComponentValidator } from "../../../shared/validation";
import { interactiveColumnComponents } from "../ListItems/shared/MultiColumnListItem.types";
import { DetailsListHeaderColumn } from "./DetailsList.types";

const minNumRows: number = 1;

export const minDetailsListRowsValidator = (rows: readonly React.ReactNode[]): ComponentValidator => (
    () => (rows.length < minNumRows ? `DetailsList cannot have less than ${minNumRows} rows` : undefined)
);

export const matchingRowsAndHeadersDetailsListValidator = (length: number, headers: readonly React.ReactNode[]): ComponentValidator => (
    () => (length !== headers.length ? `DetailsList must have the same number of columns in the headers and rows` : undefined)
);

export const validSortStatus = (headers: readonly DetailsListHeaderColumn[]) => {
    let isSorted = false;
    let isValidSort = true;
    headers.forEach(function (header) {
        if (header.headerType === "detailsHeader") {
            if (header.sortStatus === "sortedAscending" || header.sortStatus === "sortedDescending") {
                isSorted ? isValidSort = false : isSorted = true;
            }
        }
    });

    return isValidSort;
};

// Only one column header can be sorted ascending or sorted descending. The rest have to have the status of "notSortable" or "notSorted".
export const sortStatusDetailsListValidator = (headers: readonly React.ReactNode[]): ComponentValidator => (
    () => (!validSortStatus(headers as DetailsListHeaderColumn[]) ? `Only one column header can be sorted ascending or descending` : undefined)
);

export const isInteractiveListItemColumn = (element: JSX.Element) => {
    return interactiveColumnComponents.includes(element.type);
};
